/* ============================================================
   Featured Products JS (featured-products.liquid)
   Simple scroll — wrapper is the scroll container
   ============================================================ */
(function () {
  'use strict';

  qsa('.featured-products').forEach(section => {
    const wrap  = section.querySelector('.js-pslider-wrap');
    const track = section.querySelector('.js-product-slider');
    if (!wrap || !track) return;

    function cardWidth() {
      const card = track.querySelector('li');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    }

    const prevBtns = qsa('.js-pslider-prev', section);
    const nextBtns = qsa('.js-pslider-next', section);

    prevBtns.forEach(btn => btn.addEventListener('click', () => {
      wrap.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    }));
    nextBtns.forEach(btn => btn.addEventListener('click', () => {
      wrap.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    }));
  });
})();
